// A watched/reserved slot is identified by "venueId|date|courtId|time"
// everywhere it's stored: the client's local storage, the server's
// watches.json and reservations.json, and the emails built from them. The
// format therefore has to be built and parsed identically on both sides,
// which is why it lives here rather than in either one.

export function slotKey(venueId: string, date: string, courtId: string, time: string): string {
  return `${venueId}|${date}|${courtId}|${time}`;
}

export function parseSlotKey(key: string): { venueId: string; date: string; courtId: string; time: string } {
  const [venueId, date, courtId, time] = key.split('|');
  return { venueId, date, courtId, time };
}

// HAMR used to be one aggregate pseudo-court per venue ("agg"), which is now
// expanded into per-court rows numbered from 1 (see server/hamr.ts) — an old
// "agg" key means exactly what "Kurt 1" means today ("at least one court
// free"), so it's carried over rather than silently pointing at a row that no
// longer exists. Harmless for every other venue: no court is named "agg".
// Applied on load by both sides, so the two must agree — hence one copy.
export function migrateSlotKey(key: string): string {
  const { venueId, date, courtId, time } = parseSlotKey(key);
  return courtId === 'agg' ? slotKey(venueId, date, '1', time) : key;
}
